import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height: number;
  width: number;
  color?: string;
}

const IconPdfFile = (props: SvgComponentProps) => {
  const { width, height, color = "#FF5630" } = props;

  return (
    <SvgWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 15 16"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.0813 3.995L10.3912 0.2825L9.9975 0.125H1.3125L0.75 0.6875V6.875H1.875V1.25H8.625V5.1875L9.1875 5.75H13.125V6.875H14.25V4.4L14.0813 3.995ZM9.75 4.625V1.25L13.125 4.625H9.75ZM1.3125 8L0.75 8.5625V15.3125L1.3125 15.875H13.6875L14.25 15.3125V8.5625L13.6875 8H1.3125ZM13.125 13.625V14.75H1.875V9.125H13.125V13.625ZM4.125 12.5H3.765V13.625H3V10.25H4.1925C5.03625 10.25 5.46375 10.655 5.46375 11.375C5.46593 11.528 5.43487 11.6797 5.37271 11.8195C5.31056 11.9594 5.21879 12.0841 5.10375 12.185C4.82495 12.4023 4.47822 12.5139 4.125 12.5ZM4.0575 10.8688H3.765V11.915H4.0575C4.4625 11.915 4.665 11.735 4.665 11.3863C4.665 11.0375 4.4625 10.8688 4.0575 10.8688ZM8.625 13.1525C8.79115 12.9889 8.92106 12.7921 9.00634 12.5751C9.09161 12.358 9.13033 12.1255 9.12 11.8925C9.12 10.7675 8.52375 10.25 7.32 10.25H6.1275V13.625H7.32C7.55797 13.6365 7.79586 13.6007 8.01987 13.5196C8.24389 13.4385 8.44957 13.3137 8.625 13.1525ZM6.88125 13.0062V10.8688H7.2525C7.39599 10.8596 7.53983 10.8799 7.67523 10.9282C7.81063 10.9766 7.93475 11.052 8.04 11.15C8.13535 11.2501 8.20943 11.3685 8.25777 11.4981C8.30611 11.6276 8.3277 11.7656 8.32125 11.9038C8.3381 12.2003 8.237 12.4915 8.04 12.7137C7.93701 12.8123 7.81515 12.889 7.68175 12.9393C7.54836 12.9896 7.40617 13.0123 7.26375 13.0062H6.88125ZM11.8875 12.32H10.7963V13.625H10.0312V10.25H11.9887V10.8688H10.7963V11.7013H11.8875V12.32Z"
          fill={color}
        />
      </svg>
    </SvgWrapper>
  );
};

export default IconPdfFile;
